import {
  BasicButton,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  PrimaryButton,
  SelectItem,
  Select,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useLanguageOptions } from "../../hooks/api/useLanguageOptions";
import { useLanguage } from "../../hooks/useLanguage";

export function LanguageModal() {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    i18n.resolvedLanguage ?? i18n.language
  );
  const { languageOptions } = useLanguageOptions();
  const { changeLanguage } = useLanguage();

  return (
    <Dialog>
      {({ close }) => (
        <>
          <DialogHeader>{t("Language and region")}</DialogHeader>
          <DialogContent>
            <Text style="form/body-secondary" color="text-weak">
              <Trans>
                This will change the language settings within your profile.
              </Trans>
            </Text>
            {languageOptions && (
              <div
                className={css({
                  marginTop: "var(--space-2)",
                })}
              >
                <Select
                  items={languageOptions}
                  testID="language-select"
                  selectedKey={selectedLanguage}
                  name="language"
                  aria-label={t("Language")}
                  onSelectionChange={(key) =>
                    setSelectedLanguage(key?.toString() ?? "")
                  }
                >
                  {languageOptions?.map((language) => (
                    <SelectItem
                      id={language.value}
                      textValue={language.display_value}
                      key={language.value}
                    >
                      {language.display_value}
                    </SelectItem>
                  ))}
                </Select>
              </div>
            )}
          </DialogContent>
          <DialogFooter>
            <ButtonGroup>
              <BasicButton size="medium" onPress={close}>
                <Trans>Cancel</Trans>
              </BasicButton>
              <PrimaryButton
                onPress={async () => {
                  await changeLanguage(selectedLanguage);
                  close();
                }}
                size="medium"
              >
                <Trans>Save</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </DialogFooter>
        </>
      )}
    </Dialog>
  );
}
